<div class="page-content faq_section">
    <app-toaster *ngIf="showToast" [message]="toastMessage" [type]="toastType"></app-toaster>
    <div class="container pt-150 pb-150">

        <app-membership-status [membershipStatus]="StatusService.membershipStatus()"></app-membership-status>


        <div class="row">
            <!-- SIDE MENU -->
            <div class="col-md-3">
                <div class="dashboard-menu">
                    <ul class="nav flex-column">
                        <li *ngIf="isAdmin" class="nav-item">
                            <a [routerLink]="'/profile/dashboard'" routerLinkActive="active"
                                [routerLinkActiveOptions]="{ exact: true }" class="nav-link">
                                {{"PROFILE.CONTROL_PANEL" | translate}}
                            </a>
                        </li>

                        <li class="nav-item">
                            <a routerLink="/profile/memberships" class="nav-link" routerLinkActive="active"
                                [routerLinkActiveOptions]="{ exact: true }">
                                {{"PROFILE.MEMBESRHIPS" | translate}}
                            </a>
                        </li>

                        <li class="nav-item">
                            <a routerLink="/profile/details" class="nav-link" routerLinkActive="active"
                                [routerLinkActiveOptions]="{ exact: true }">
                                {{"PROFILE.PROFILE_DETAILS" | translate}}
                            </a>
                        </li>

                        <li class="nav-item cursor-pointer">
                            <a class="nav-link cursor-pointer" (click)="logout()">
                                {{"PROFILE.LOGOUT" | translate}}
                            </a>
                        </li>
                    </ul>
                </div>
            </div>

            <!-- CONTENT -->
            <div class="col-md-9">
                <router-outlet></router-outlet>
            </div>

        </div>
    </div>
</div>
<app-apply-for-membership (membershipStatusChanged)="onMembershipStatusChanged($event)"></app-apply-for-membership>